import { ExtendedPractitioner } from '@seen/core/models/practitioner'
import type { ValidatedToolResponse } from '@seen/core/models/validatedToolResponse'
import { DotSeparator, TypographySubtle } from '@seen/ui'
import type { JSX, ReactNode } from 'react'
import { Avatar } from '#src/components/core/Avatar/Avatar.tsx'
import { Card } from '#src/components/core/Card.tsx'
import { HoverDate } from '#src/components/core/hover-card/HoverDate.tsx'
import { HoverPractitioner } from '#src/components/core/hover-card/HoverPractitioner.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export interface ValidatedToolResponseCardProps {
  response: ValidatedToolResponse
  children: ReactNode
}

export function ValidatedToolResponseCard({
  children,
  response,
}: ValidatedToolResponseCardProps): JSX.Element {
  const { data: author } = useRead(ExtendedPractitioner, response.author)
  return (
    <Card className="flex max-w-96 flex-col gap-3 px-4">
      {children}
      <div className="flex items-center gap-1.5 self-end">
        <TypographySubtle className="pr-0.5 text-foreground-tertiary">
          –
        </TypographySubtle>
        <Avatar profile={response.author} size="icon" />
        <TypographySubtle className="text-foreground-secondary">
          <HoverPractitioner practitioner={author} />
          <DotSeparator />
          <HoverDate date={response.authored} />
        </TypographySubtle>
      </div>
    </Card>
  )
}
